import { getField, updateField } from "vuex-map-fields";
import mutations from "./mutations"
import * as actions from "./actions"
export default {
    namespaced: true,
    state: {
        isLoading: false,
        update: {},
        isUpdated:false,
        showMessage: false,
        message: "",
        isSuccess: false,
        currentItem: null,
        modal: {
            title: "__",
            description: "__",
            type: "default",
            content: '',


        },
        showModal: false,

    },
    actions,
    getters: {
        getField,

    },
    mutations: {
        updateField,
        ...mutations,
    },
}


// {
//     field: 'actions', title: 'Actions', hide: false, cellRenderer: () => {
//         return ` `
//     }
// },